<template>
	<div class="news">

		<section class="banner">
			<div class="img">
				<img :src="`${publicPath}images/banner-news.jpg`">
			</div>
			<div class="container">
				<h1>{{ $t('news') }}</h1>
			</div>
		</section>

		<section class="news-list">
			<div class="container">
				<div class="news-item" v-for="(item, index) in news">
					<div class="thumb"><img :src="item.coverImg"></div>
					<div class="detail">
						<h2>{{ item.title }}</h2>
						<p v-if="item.content" v-html="item.content.substring(0, 100) + '...'"></p>
						<router-link :to="{ path: '/news/' + item.id }">Read more</router-link>
					</div>
				</div>

				<!-- <div class="news-item">
					<div class="thumb"><img :src="`${publicPath}images/temp-news.png`"></div>
					<div class="detail">
						<h2>正確認識哮喘 了解用藥目標︱曹忠豪醫生 (壹週刊)</h2>
						<p>哮喘是氣管敏感的症狀，每名患者都會有各自的致敏原令哮喘發作，包括塵蟎、空氣污染或運動等。一般而言，當哮喘發作時，患者會出現咳嗽、氣喘及呼吸困難等情況，此時患者可使用短效氣管舒張劑作紓緩。.....</p>
						<router-link to="news/detail">Read more</router-link>
					</div>
				</div>

				<div class="news-item">
					<div class="thumb"><img :src="`${publicPath}images/temp-news.png`"></div>
					<div class="detail">
						<h2>正確認識哮喘 了解用藥目標︱曹忠豪醫生 (壹週刊)</h2>
						<p>哮喘是氣管敏感的症狀，每名患者都會有各自的致敏原令哮喘發作，包括塵蟎、空氣污染或運動等。一般而言，當哮喘發作時，患者會出現咳嗽、氣喘及呼吸困難等情況，此時患者可使用短效氣管舒張劑作紓緩。.....</p>
						<router-link to="news/detail">Read more</router-link>
					</div>
				</div> -->
			</div>
		</section>


		<footer>
			<div class="container">
				<div class="copyright">
					Copyright &copy; 2019 GraceMed. All Rights Reserved.
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { db } from '../main'

export default {
	name: 'contactus',
	components: {

	},
	data () {
		return {
			publicPath: process.env.BASE_URL,
			mobileNav: false,
			news: []
		}
	},
	methods: {
		toggleMobileNav() {
			this.mobileNav = !this.mobileNav
		}
	},
	created() {
		this.$bind('news', db.collection('news').orderBy('createdAt', 'desc'))

		console.log(this.news);
	}
}
</script>

<style>
.news .banner .img {
	position: relative;	
}

.news .banner img {
	width: 100%;
	max-width: 100%;
}

.news h1 {
	color: #9c8b72;
}

.news-list {
	padding: 25px 0;
}

.news-list .news-item {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 50px 0;
	border-top: 1px solid #9c8b72;
}

.news-list .news-item:first-child {
	border: none;
}

.news-list .thumb {
	width: 35%;
	margin: 0 5%;
}

.news-list .detail {
	width: 50%;
}

.news-list .thumb img {
	width: 100%;
}

.news-item h2 {
	font-size: 20px;
	color: #f39d00;
}

.news-item a {
	text-decoration: none;
	color: #f39d00;
}

@media handheld,only screen and (max-width: 800px) {
	.news h1 {
		position: relative;
		color: #e39200;
		font-size: 2em;
		text-align: center;
		padding: 20px 0 0 0;
		margin: 0;
	}

	.news-list {
		padding: 0 0 25px 0;
	}

	.news-list .news-item {
		padding: 50px 0;
		flex-direction: column;
	}

	.news-list .news-item:first-child {
		padding-top: 20px;
	}

	.news-list .thumb {
		width: 100%;
	}

	.news-list .detail {
		width: 100%;
	}
}
</style>